import { Injectable } from '@angular/core';
import {
  DateStringParser,
  DateStringParserStrategyFactory
} from './../../../util/src/lib/date-string-parser';
import { AppConfig } from './../../config/app.config';

@Injectable({
  providedIn: 'root',
})
export class DateService {
  constructor(private appConfig: AppConfig) {}

  /**
   * @description 依據系統設定國別代碼將日期字串轉換為 Date
   *
   * @param date 日期字串(因國家不同會有不同格式)
   * @return Date 物件，無法轉換回傳 null
   */
  parseDateStringToDate(date: string): Date | null {
    const dateStringParserStrategy = DateStringParserStrategyFactory.create(
      this.appConfig.countryId
    );
    const dateStringParser = new DateStringParser(dateStringParserStrategy);
    return dateStringParser.doParse(date);
  }
}
